import * as React from 'react';
export const dataSvg = React.forwardRef(function dataSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 2.75C1 1.231 3.239 0 6 0s5 1.231 5 2.75a1.6 1.6 0 0 1-.02.25H11v6.5c0 1.38-2.239 2.5-5 2.5s-5-1.12-5-2.5V3h.02A1.544 1.544 0 0 1 1 2.75Zm1.4 0c0-.013.028-.326.74-.718C3.8 1.668 4.81 1.4 6 1.4s2.2.268 2.86.632c.713.392.74.705.74.718 0 .013-.027.326-.74.718C8.2 3.832 7.19 4.1 6 4.1s-2.2-.268-2.86-.632c-.712-.392-.74-.705-.74-.718Zm0 1.908v1.636c.129.122.324.262.601.4.706.353 1.764.606 2.999.606s2.293-.253 2.999-.606c.277-.138.472-.278.601-.4V4.658c-.91.52-2.186.842-3.6.842-1.414 0-2.69-.323-3.6-.842Zm0 4.842V7.735c.91.472 2.186.765 3.6.765 1.414 0 2.69-.293 3.6-.765V9.5h-.014c-.042.074-.187.27-.677.515-.672.337-1.699.585-2.909.585-1.21 0-2.237-.248-2.91-.585-.49-.244-.634-.441-.676-.515H2.4Z',
    }),
  );
});
dataSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var data = {
  category: 'icon',
  colorable: true,
  name: 'data',
  svg: dataSvg,
};
